import React from "react";

const blogData = [
  {
    image: "/assets/knowyourself/blogs/blog1/Picture1.png",
    title: "Why You’re Doing “All the Right Things” — But Still Don’t Feel Alright",
    excerpt:"Inspired by the timeless wisdom of Yoga, Ayurveda, and Positive Psychology, we present to you the full-circle framework to elevate your..",
    link: "/wellness-blogs/four-pillar-approach-of-holistic-well-being",
  },
  {
    image: "/assets/knowyourself/blogs/blog2/b2p1.jpg",
    title: "“Bro, What’s Your Protein Intake?” — And Other Myths About Food",
    excerpt:"Food doesn’t just shape your body, It shapes your thoughts, your emotions, your tendencies, your sleep, your energy, your destiny.We say: “Jaisa Ann, Vaisa Mann.” As the food, so the mind..",
    link: "/wellness-blogs/food-beyond-fuel",
  },
  {
    image: "/assets/knowyourself/blogs/blog3/b3p1.png",
    title: "“Just 5 Minutes on Instagram” — And Other Lies We Tell Ourselves",
    excerpt:"We are the generation with limitless information… and zero concentration.Our devices are glowing. But our willpower? Flickering..",
    link: "/wellness-blogs/science-of-scattered-minds",
  },
 {
  image: "/assets/knowyourself/blogs/blog4.png",
  title: "Never Do These 7 Mistakes After 30 (Or You’ll Regret It Later)",
  excerpt: "Turning 30 changes how your body and mind speak to you. This blog uncovers 7 silent mistakes that drain your energy, focus, and peace — and how to fix them before they become habits.",
  link: "/wellness-blogs/never-do-these-mistakes-after-30",
},
{
  image: "/assets/knowyourself/blogs/blog5.png",
  title: "10 Micro Habits That Create Massive Shifts",
  excerpt: "Big changes start with small, daily habits. Discover 10 simple actions that boost your focus, energy, and calm — helping you transform quietly from within.",
  link: "/wellness-blogs/10-micro-habits-for-massive-shifts",
},
  {
    image: "/assets/knowyourself/blogs/blog6.jpg",
    title: "🌤️ 11 Tiny Morning Habits That Reduce Stress Instantly",
    excerpt:
      "Start your day calmer and clearer with 11 tiny habits that reduce stress, boost focus, and build peace — no 5 AM routine required.",
    link: "/wellness-blogs/tiny-morning-habits",
  },
  {
    image: "/assets/knowyourself/blogs/blog7.jpg",
    title: "🌱 Are You Choosing Your Life — Or Just Settling For It?",
    excerpt:
      "Comfort feels safe, but it often keeps you small. Here’s how to break free from ‘it’s fine’ and start choosing the life you actually want.",
    link: "/wellness-blogs/choosing-or-settling",
  },
  {
    image: "/assets/knowyourself/blogs/blog8.png",
    title: "🧠 If You Don’t Program Your Mind — Someone Else Will",
    excerpt:
      "Every day, the world reminds you what to want. Learn how to stop letting external noise control your mind — and start living with conscious intention.",
    link: "/wellness-blogs/how-to-control-your-mind",
  },

{
  image: "/assets/knowyourself/blogs/blog9.jpg",
  title: "🌿 7 Things Our Grandparents Did Right (But We Ruined)",
  excerpt:
    "Our grandparents lived simpler, slower, and healthier lives — not by luck, but by wisdom. Rediscover the timeless habits they followed that brought strength, balance, and peace into everyday living.",
  link: "/wellness-blogs/things-our-grandparents-did-right",
},
{
  image: "/assets/knowyourself/blogs/blog10.png",
  title: "🌧 Why Your Life Isn’t Moving Forward",
  excerpt:
    "Feeling stuck? You’re not alone. Learn the hidden patterns that keep you looping in the same place — and the small daily shifts that can help you finally move forward with clarity and confidence.",
  link: "/wellness-blogs/why-life-feels-stuck",
},
{
  image: "/assets/knowyourself/blogs/blog11.png",
  title: "🧠 11 Simple Habits That Protect Your Mental Health Daily",
  excerpt:
    "Protecting your mental health isn’t about fixing yourself — it’s about small, human habits that help you feel safe, steady, and supported every day, even when life feels heavy.",
  link: "/wellness-blogs/11-simple-habits-that-protect-your-mental-health-daily",
},
{
  image: "/assets/knowyourself/blogs/blog12.png",
  title: "☀️ 9 Morning Habits That Power Up Your Whole Day",
  excerpt:
    "The first hour of your day shapes everything that follows. These gentle morning habits help you wake up with peace, intention, and energy that lasts far beyond breakfast.",
  link: "/wellness-blogs/9-morning-habits-that-power-up-your-whole-day",
},
{
  image: "/assets/knowyourself/blogs/blog13.png",
  title: "✨ 11 Things to Start Doing Before You Turn 30",
  excerpt:
    "Your 20s aren’t about rushing or proving anything — they’re about building inner peace. These 11 practices help you care for your mind, heal your patterns, and grow into yourself with calm and clarity.",
  link: "/wellness-blogs/11-things-to-start-doing-before-you-turn-30",
},

{
  image: "/assets/knowyourself/blogs/blog14.png",
  title: "🩺 9 Hidden Signs Your Body Needs Attention",
  excerpt:
    "You might be functioning — but your body could still be asking for care. Learn the subtle signs your body uses to communicate, and how listening can restore balance and well-being.",
  link: "/wellness-blogs/9-hidden-signs-your-body-needs-attention",
},
{
  image: "/assets/knowyourself/blogs/blog16.png",
  title: "🧠 7 Things Emotionally Intelligent People Don’t Do",
  excerpt:
    "Emotional intelligence isn’t about suppressing feelings — it’s about responding with awareness. Discover 7 habits emotionally intelligent people avoid to stay calm, grounded, and in control.",
  link: "/wellness-blogs/7-things-emotionally-intelligent-people-dont-do",
},

{
  image: "/assets/knowyourself/blogs/blog17.png",
  title: "🧘 Master This Habit — And People Will Stop Triggering You",
  excerpt:
    "Feeling easily triggered isn’t weakness — it’s a missed pause. Learn the one powerful habit that helps you respond calmly, protect your peace, and stop giving others control over your emotions.",
  link: "/wellness-blogs/master-this-habit-and-people-will-stop-triggering-you",
},

{
  image: "/assets/knowyourself/blogs/blog18.png",
  title: "🪞 10 Signs You’re Acting as Your Own Worst Enemy",
  excerpt:
    "Sometimes the biggest obstacle isn’t the world — it’s your inner patterns. Explore 10 subtle ways you may be self-sabotaging and how awareness can turn you into your own strongest ally.",
  link: "/wellness-blogs/10-signs-youre-acting-as-your-own-worst-enemy",
},

{
  image: "/assets/knowyourself/blogs/blog15.png",
  title: "🌿 8 Everyday Triggers That Are Silently Destroying Your Gut",
  excerpt:
    "Your gut responds not just to food, but to stress, speed, and emotion. Learn the everyday habits that quietly weaken digestion — and how gentle awareness can restore balance and vitality.",
  link: "/wellness-blogs/8-everyday-triggers-that-are-silently-destroying-your-gut",
},
{
  image: "/assets/knowyourself/blogs/blog19.png",
  title: "🌸 9 Health Priorities Every Woman Over 25 Can’t Afford to Miss",
  excerpt:
    "Your body isn’t asking for perfection — it’s asking for attention. Discover the essential health priorities every woman over 25 needs to protect her energy, hormones, and emotional balance before burnout begins.",
  link: "/wellness-blogs/9-health-priorities-every-woman-over-25",
},
{
  image: "/assets/knowyourself/blogs/blog20.png",
  title: "💫 9 Habits Women Over 30 Should Ditch to Boost Their Hormonal Health",
  excerpt:
    "Your hormones aren’t rebelling — they’re communicating. Learn the everyday habits that silently disrupt hormonal balance after 30, and the gentle shifts that restore calm, energy, and well-being.",
  link: "/wellness-blogs/9-habits-women-over-30-should-ditch-for-hormonal-health",
},

 ];

const BlogCard = ({ item }) => (
  <div className="bg-white shadow-md rounded-md overflow-hidden md:flex items-stretch">
    <div className="md:w-1/3">
      <img src={item.image} alt={item.title} className="w-full h-40 object-cover md:h-full" />
    </div>
    <div className="p-5 md:w-2/3 flex flex-col justify-between">
      <div className="flex flex-col flex-grow space-y-2">
        <h2 className="text-xl font-bold text-primary">{item.title}</h2>
        <span className="text-xs text-gray-500">{item.category}</span>
        <p className="text-gray-700">{item.excerpt}</p>
      </div>
      <div className="mt-3">
        <a href={item.link} className="text-[#578d48] font-semibold hover:underline inline-block">
          Read more...
        </a>
      </div>
    </div>
  </div>
);

const BlogSection = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8 space-y-6">
      <h2 className="text-2xl md:text-4xl font-extrabold text-center text-[#578d48] md:mt-8 mt-4 mb-4 md:mb-10">Read Blogs</h2>
      {blogData.map((item, index) => (
        <BlogCard key={index} item={item} />
      ))}
    </div>
  );
};

export default BlogSection;
